const CL = 'es-CL';

export function format(amount: number, options = {}) {
  return amount.toLocaleString(CL, options);
}

export function formatToMM(amount: number, options = {}): string {
  const millions = amount / 1000000;
  return format(millions, options);
}
